<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YiXN3f/tc-custom/9781466815070.jpg?1728259177765" alt="This image is the cover for the book Doctor Digs a Grave, Dr. Fenimore Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doctor Digs a Grave, Dr. Fenimore Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Winner of the Agatha Award and the SMP/Malice Domestic Competition for Best First Traditional Mystery Novel</b><br/><br/><b>Available for house calls-- and homicide...</b><br/><br/>When cardiologist Dr. Andrew Fenimore isn't mending weak hearts, he's solving crimes in Philadelphia's wealthy Society Hill. But murder is the last thing the good doctor expects when he befriends a teenage boy trying to bury his dead cat. As the two dig a grave for the cat's final resting place in a vacant lot-- which happens to be an ancient burial ground-- they discover a fresh corpse, buried feet flexed, facing east, according to Lenape Indian tradition.<br/><br/>Fenimore's P.I. pastime starts to become a distinct health hazard as he and his young sidekick follow the trail of the deceased young woman straight to the son of a colleague, one of Philadelphia's most prominent surgeons. Surely the scion of a fine old Philadelphia family and his Indian fiancee ignited some powerful passions. But are they enough to risk trying for the perfect murder in a place where civility rules with an iron fist in a velvet glove?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Hathaway
      </h2>
      
      <p class="authorDescription body article"><B>Robin Hathaway</B> (1934-2013) won the SMP/Malice Domestic Competition for Best First Traditional Mystery Novel in 1997 and the 1998 Agatha Award for Best First Novel for her book <I>The Doctor Digs a Grave,</I> the first book in the Dr. Fenimore series. She lived in New York City and Philadelphia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9919c256